var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-link',{attrs:{"to":_vm.pageUrl}},[_vm._v(_vm._s(_vm.title))]),_c('a',{on:{"click":function($event){return _vm.openInNewTab(_vm.pageUrl)}}},[_c('i',{staticClass:"far fa-window-restore newtab"})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }